import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punestationtomumbaicab() {



const cardData = {
  keyword: " Pune Station to Mumbai Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Pune Station to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Pune Station to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune Station to Mumbai cab travel.",

topPlaces: [

  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most celebrated landmark, overlooking the Arabian Sea. Renting an Innova Crysta in Pune makes the road trip convenient for families and groups planning a memorable sightseeing experience. Visitors can admire the monument's architecture, enjoy ferry rides, and explore nearby heritage attractions in South Mumbai."
  },
  {
    title: "Phoenix Marketcity",
    description: "Phoenix Marketcity is one of Mumbai's premier shopping and entertainment destinations, featuring luxury brands, restaurants, gaming zones, and multiplex cinemas. Travelers hiring an Innova Crysta on rent in Pune can spend an enjoyable day shopping, dining, and relaxing with family and friends in this modern lifestyle destination."
  },
    {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples, attracting thousands of devotees throughout the year. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable journey to this sacred destination while exploring its beautiful architecture, peaceful surroundings, and nearby coastal viewpoints. It is an excellent place for spiritual visits and cultural exploration."
  },
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation estimated to be over 66 million years old. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore this unique geological landmark and enjoy panoramic views of Mumbai from the hilltop temple. It is a hidden gem perfect for photography and sightseeing."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a scenic seaside promenade offering spectacular views of the Arabian Sea and the Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a relaxing drive before taking peaceful walks, visiting nearby cafés, and exploring one of Mumbai's most popular waterfront locations."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this historic destination and explore centuries-old caves, sculptures, meditation halls, and lush green surroundings ideal for history lovers and adventure seekers."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a beautiful waterfront promenade where visitors can enjoy cool sea breezes, scenic views, and spectacular sunsets. Renting an Innova Crysta in Pune ensures a comfortable road trip for families and groups looking to relax by Mumbai's coastline and capture memorable photographs."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest aquariums, showcasing a fascinating variety of marine and freshwater species. Travelers hiring an Innova Crysta on rent in Pune can conveniently visit this family-friendly attraction, making it an enjoyable destination for children, students, and marine life enthusiasts."
  },
  {
    title: "Crawford Market",
    description: "Crawford Market is a historic shopping destination famous for fresh produce, spices, dry fruits, handicrafts, and imported goods. Booking an Innova Crysta on rent in Pune allows visitors to comfortably explore this vibrant marketplace while experiencing Mumbai's rich local culture and colonial architecture."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic coastal roads. Travelers choosing an Innova Crysta on rent in Pune can enjoy a scenic journey before relaxing along the promenade, watching the sunset over the Arabian Sea, and experiencing the lively atmosphere that makes Marine Drive a favorite among visitors."
  }
],



services: [
{
name: "Pune Station to Dadar Taxi Fare",
description: "Pune Station to Dadar taxi fare service provides transparent pricing for passengers traveling from Pune Railway Station to Dadar in Mumbai. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide safe driving and punctual pickup directly from Pune station."
},
{
name: "Pune Station to Mumbai Airport Taxi",
description: "Pune Station to Mumbai Airport taxi service offers reliable airport transportation from Pune Railway Station to Chhatrapati Shivaji Maharaj International Airport. Comfortable vehicles with luggage space ensure convenient airport transfers."
},
{
name: "Pune Station to Mumbai One Way Cab",
description: "Pune Station to Mumbai one way cab service provides convenient single-trip transportation between Pune Railway Station and Mumbai city. Comfortable vehicles ensure smooth highway travel with experienced drivers."
},
{
name: "Pune Station to Mumbai Airport Innova Crysta",
description: "Pune Station to Mumbai Airport Innova Crysta cab service offers premium SUV airport transportation for travelers. Spacious seating and luggage capacity make the Innova Crysta ideal for airport journeys."
},
{
name: "Pune Station to Mumbai Ertiga Cab",
description: "Pune Station to Mumbai Ertiga cab service offers comfortable 7-seater SUV transportation between Pune Railway Station and Mumbai city. The vehicle provides spacious seating and smooth highway travel."
},
{
name: "Shivaji Nagar to Mumbai Cab Fare",
description: "Shivaji Nagar to Mumbai cab fare service provides transparent pricing for passengers traveling from Shivaji Nagar in Pune to Mumbai city. Vehicles are comfortable and suitable for expressway travel."
},
{
name: "Pune Station to Borivali Taxi",
description: "Pune Station to Borivali taxi service provides dependable transportation between Pune Railway Station and Borivali in Mumbai. Comfortable vehicles and professional drivers ensure safe journeys."
},
{
name: "Pune Station to Navi Mumbai Cab Fare",
description: "Pune Station to Navi Mumbai cab fare service provides affordable pricing for passengers traveling from Pune Railway Station to Navi Mumbai. Vehicles are comfortable and suitable for highway travel."
},
{
name: "Pune Station to Mumbai Airport Cab Fare",
description: "Pune Station to Mumbai Airport cab fare service provides clear fare estimates for travelers heading to Mumbai Airport from Pune Railway Station. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune Station to Mumbai Sedan Taxi Fare",
description: "Pune Station to Mumbai sedan taxi fare service offers economical transportation using comfortable sedan vehicles like Swift Dzire and Etios. Professional drivers ensure smooth expressway travel."
},
{
name: "Ertiga on Rent in Pune Station",
description: "Ertiga on rent in Pune Station offers spacious 7-seater SUV transportation for families and groups. The vehicle is suitable for airport transfers, city rides, and outstation journeys."
},
{
name: "Innova Ertiga Xylo Tavera Car on Rent Pune Station",
description: "SUV car rental near Pune Station offers vehicles like Innova, Ertiga, Xylo, and Tavera for comfortable outstation travel. Spacious seating makes these vehicles ideal for family trips and airport transfers."
},
{
name: "Pune Station to Mumbai Airport Cab",
description: "Pune Station to Mumbai Airport cab service provides dependable airport transportation from Pune Railway Station to Mumbai Airport terminals. Vehicles ensure comfortable seating and safe expressway travel."
},
{
name: "Pune Station to Mumbai Airport Innova",
description: "Pune Station to Mumbai Airport Innova cab service offers premium SUV airport transportation. Spacious seating and luggage capacity make the Innova ideal for airport journeys."
},
{
name: "Pune to Mumbai Velocity Cabs",
description: "Pune to Mumbai Velocity Cabs offers dependable transportation services between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for city rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Comfortable vehicles ensure smooth expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Pune Station Cab",
description: "Pune Station cab service provides quick taxi availability for passengers arriving at or departing from Pune Railway Station. Vehicles are comfortable and suitable for city rides and airport transfers."
},
{
name: "Full Day Taxi in Pune",
description: "Full day taxi in Pune service provides flexible transportation for local travel, meetings, sightseeing, and business visits. Vehicles remain available for the entire day with professional drivers."
},
{
name: "Katraj to Mumbai Cab",
description: "Katraj to Mumbai cab service offers reliable transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Katraj to Mumbai Taxi",
description: "Katraj to Mumbai taxi service provides dependable intercity transportation between Pune and Mumbai city with comfortable vehicles."
},
{
name: "Katraj to Mumbai Cab Service",
description: "Katraj to Mumbai cab service provides convenient transportation between Pune and Mumbai with professional drivers ensuring safe highway journeys."
},
{
name: "Katraj to Mumbai Taxi Service",
description: "Katraj to Mumbai taxi service offers reliable travel options for passengers heading from Pune to Mumbai with comfortable vehicles."
},
{
name: "Katraj to Mumbai Cab Booking",
description: "Katraj to Mumbai cab booking service allows passengers to easily reserve taxis for intercity travel. Flexible booking options ensure convenient travel planning."
},
{
name: "Cab from Katraj to Mumbai",
description: "Cab from Katraj to Mumbai service offers dependable transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway journeys."
}
],

tableData: [
["Pune Station to Dadar Taxi Fare","Pune Station to Mumbai Airport Taxi"],
["Pune Station to Mumbai One Way Cab","Pune Station to Mumbai Airport Innova Crysta"],
["Pune Station to Mumbai Ertiga Cab","Shivaji Nagar to Mumbai Cab Fare"],
["Pune Station to Borivali Taxi","Pune Station to Navi Mumbai Cab Fare"],
["Pune Station to Mumbai Airport Cab Fare","Pune Station to Mumbai Sedan Taxi Fare"],
["Ertiga on Rent in Pune Station","Innova Ertiga Xylo Tavera Car on Rent Pune Station"],
["Pune Station to Mumbai Airport Cab","Pune Station to Mumbai Airport Innova"],
["Pune to Mumbai Velocity Cabs","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Pune Mumbai Cab"],
["Pune Station Cab","Full Day Taxi in Pune"],
["Katraj to Mumbai Cab","Katraj to Mumbai Taxi"],
["Katraj to Mumbai Cab Service","Katraj to Mumbai Taxi Service"],
["Katraj to Mumbai Cab Booking","Cab from Katraj to Mumbai"]
],





whychoose: [
  {
    WhyChooseheading: "Convenient Pickup from Pune Railway Station",
    WhyChoosedescription: "Velocity Cabs provides quick and convenient pickup from Pune Railway Station for passengers traveling to Mumbai. Our drivers are familiar with station pickup points and ensure timely pickup even during busy train schedules."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides professional drivers who regularly travel between Pune and Mumbai via the Mumbai Pune Expressway. Their experience ensures safe driving and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Pune Station to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pune Station to Mumbai cab service operates 24 hours a day. Whether your train arrives early morning or late night, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Pune Railway Station to Mumbai."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune Station to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Pune Railway Station to Mumbai?", answer: "Yes, Velocity Cabs provides reliable cab services from Pune Railway Station to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Pune Station to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match train arrival and departure schedules." },
  { question: "Which vehicles are available for Pune Station to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune Station to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Pune Railway Station and Mumbai." },
  { question: "Will the driver wait if my train is delayed?", answer: "Yes, our drivers monitor train schedules and coordinate with passengers for smooth pickup even if the train is delayed." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Pune Station to Mumbai cab services online or through phone booking." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, Velocity Cabs provides direct drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Smooth pickup from Pune Railway Station made the Mumbai journey very comfortable. The cab was clean, and the ride felt relaxed and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "A hassle-free travel experience from Pune Railway Station to Mumbai. The vehicle was on time, well-maintained, and the entire trip felt safe and convenient.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Pune Station to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, Innova Crysta, and Sedan cabs for airport transfers, Dadar, Borivali, Navi Mumbai, Shivaji Nagar, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Pune Station to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};


  return (
    <div>
      
<Helmet>
  <title>Pune Station to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Station to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Ertiga, Innova, Innova Crysta & Sedan for Dadar, Borivali, Navi Mumbai & Shivaji Nagar." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punestationtomumbaicab;